/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React, {Component} from 'react';
import {Button, Card, Col, DatePicker, Form, Row, Select, Spin, Table} from 'antd';
import {sanitizeFieldName} from "../../util/methods";
import moment from "moment/moment";

class ASTCombineReport extends Component {

  state = {
    availableForDownload: false
  }

  componentDidMount() {
    this.props.fetchLocSubLoc();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.combineReportData && nextProps.combineReportData.length) {
      this.setState({
        availableForDownload: true
      })
    } else {
      this.setState({
        availableForDownload: false
      })
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      this.props.fetchReportData(values);
    });
  };

  handleDownload = () => {
    this.props.downloadCombineData(this.props.combineReportData);
  };

  render() {
    const {getFieldDecorator, setFieldsValue} = this.props.form;
    const {loading, title, resource, locationData, subLocationData, combineReportData} = this.props;
    const cols = [{title: 'AST', dataIndex: 'astNo', key: 'astNo', width: 100},
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        width: 100,
        render: (location) => location && location.name
      },
      {
        title: 'Sub Location',
        dataIndex: 'subLocation',
        key: 'subLocation',
        width: 100,
        render: (subLocation) => subLocation && subLocation.name
      },
      {title: 'Status', dataIndex: 'status', key: 'status', width: 100,},
      {
        title: 'Submitted By',
        dataIndex: 'submittedBy',
        key: 'submittedBy',
        width: 120,
        render: (submittedBy) => submittedBy && submittedBy.name
      },
      {title: 'Opened By', dataIndex: 'user', key: 'user', width: 120, render: (user) => user && user.name},
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 100,
        render: (createdAt) => createdAt && moment(createdAt).format('DD-MM-YYYY')
      },
      {
        title: 'Asset',
        dataIndex: 'asset',
        key: 'asset',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.assetCode
      },
      {
        title: 'Condition',
        dataIndex: 'condition',
        key: 'condition',
        width: 120,
        render: (_, record) => record.assetDetails && record.assetDetails.condition && record.assetDetails.condition.name
      },
      {
        title: 'Entry Type',
        dataIndex: 'entryType',
        key: 'entryType',
        width: 100,
        render: (_, record) => (record.assetDetails && record.assetDetails.manual) ? 'Manual' : 'QR'
      },
      {
        title: 'QR Mismatched',
        dataIndex: 'isQrMismatched',
        key: 'isQrMismatched',
        width: 100,
        render: (_, record) => (record.assetDetails && record.assetDetails.isQrMismatched) ? 'Yes' : 'No'
      },
      {
        title: 'AT No',
        dataIndex: 'link_record',
        key: 'link_record',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.link_record
      },
      {
        title: 'QR Id',
        dataIndex: 'qrId',
        key: 'qrId',
        width: 100,
        render: (_, record) => {
          let tag = record.assetDetails && record.assetDetails.assetTagging; // && record.assetDetails.assetTagging.length && record.assetDetails.assetTagging[record.assetDetails.assetTagging.length - 1].id
          tag = (tag || []).filter(t => t.asset === (record.assetDetails.asset && record.assetDetails.asset[0]._id) || t.asset === (record.assetDetails.asset && record.assetDetails.asset[0].assetCode));
          const assetTag = tag && tag.length && tag[tag.length - 1];
          const scanData = assetTag && assetTag.scannerData || [];
          return scanData && scanData.length && scanData[scanData.length - 1] && scanData.length && scanData[scanData.length - 1].id || '';
        }
      },
      {
        title: 'Latitude',
        dataIndex: 'lat',
        key: 'lat',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.latitude
      },
      {
        title: 'Longitude',
        dataIndex: 'lng',
        key: 'lng',
        width: 100,
        render: (_, record) => record.assetDetails && record.assetDetails.longitude
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
        key: 'remark',
        width: 150,
        render: (_, record) => record.assetDetails && record.assetDetails.remarks
      },
      {
        title: 'Time',
        dataIndex: 'time',
        key: 'time',
        width: 120,
        render: (_, record) => record.assetDetails && record.assetDetails.time && moment(record.assetDetails.time).format('hh:mm:ss')
      },
      {
        title: 'Attachments',
        dataIndex: 'attachments',
        key: 'attachments',
        width: 200,
        render: (_, record) => {
          let photos = '--';
          if (record.assetDetails && record.assetDetails.photos && record.assetDetails.photos.length) {
            photos = record.assetDetails.photos.map((photo, index) => (
              <span key={`P${index}`}>
                <a target='_blank' key={photo.url} href={photo.url}> {`Attachment-${(index + 1)}`}</a>
                <br/>
              </span>))
          }
          return (<span>{photos}</span>);
        }
      },
    ];

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${sanitizeFieldName(resource)} ${title}`}>
          <Form onSubmit={this.handleSubmit} className="ant-advanced-search-form" layout="inline" labelAlign="left">

            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'location'} label={'Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`location`, {
                    rules: [{required: true, message: `Location is required!`}],
                  })(<Select
                    showSearch
                    showArrow
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Select Location`}
                  >
                    <Select.Option key={'loc-all'} value={'all'}>All</Select.Option>
                    {(locationData.data || []).map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                    }
                  </Select>)
                  }
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'subLocation'} label={'Sub Location'} style={{width: '100%'}}>
                  {getFieldDecorator(`subLocation`, {
                    rules: [{required: true, message: `Sub Location is required!`}],
                  })(<Select
                    showSearch
                    showArrow
                    // onChange={value => this.handleSelect('subLocation', value)}
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    placeholder={`Select Sub Location`}
                  >
                    <Select.Option key={'sloc-all'} value={'all'}>All</Select.Option>
                    {(subLocationData.data || []).map(item =>
                      <Select.Option key={item._id}
                                     value={item._id}>{item.name}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'periodFrom'} label={'Select Period From'} style={{width: '100%'}}>
                  {getFieldDecorator(`periodFrom`, {
                    rules: [{required: true, message: `Period From is required!`}],
                    initialValue: null,
                  })(<DatePicker style={{width: '100%'}}/>)}
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                <Form.Item key={'periodTo'} label={'Select Period To'} style={{width: '100%'}}>
                  {getFieldDecorator(`periodTo`, {
                    rules: [{required: true, message: `Period To is required!`}],
                    initialValue: null,
                  })(<DatePicker style={{width: '100%'}}/>)}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Generate Report
              </Button>
              {this.state.availableForDownload && (
                <Button icon={'download'} type="secondary" htmlType="button" loading={loading}
                        onClick={this.handleDownload}>
                  Download
                </Button>)}
            </Form.Item>
          </Form>

        </Card>
        <Card>
          {combineReportData && combineReportData.length ?
            <Table
              pagination={{pageSize: 10}} bordered
              loading={loading}
              columns={cols}
              dataSource={combineReportData}
              scroll={{x: true}} size="small"
              rowKey={record => record._id + record.assetDetails.assetCode + record.createdAt}
            /> : null
          }
        </Card>
      </Spin>
    );
  }
}

export default Form.create({name: 'ast-combine'})(ASTCombineReport);
